var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.722222 0H3.25C3.64722 0 3.97222 0.325 3.97222 0.722222C3.97222 1.625 4.11667 2.49167 4.38389 3.30056C4.46333 3.55333 4.40556 3.835 4.20333 4.03722L2.61444 5.62611C3.65444 7.67 5.33 9.33833 7.37389 10.3856L8.96278 8.79667C9.10722 8.65944 9.28778 8.58722 9.47556 8.58722C9.54778 8.58722 9.62722 8.59444 9.69944 8.62333C10.5083 8.89056 11.3822 9.035 12.2778 9.035C12.675 9.035 13 9.36 13 9.75722V12.2778C13 12.675 12.675 13 12.2778 13C5.49611 13 0 7.50389 0 0.722222C0 0.325 0.325 0 0.722222 0ZM2.55667 1.44444C2.6 2.08722 2.70833 2.71556 2.88167 3.315L2.015 4.18167C1.71889 3.315 1.53111 2.39778 1.46611 1.44444H2.55667ZM9.67778 10.1256C10.2917 10.2989 10.92 10.4072 11.5556 10.4506V11.5267C10.6022 11.4617 9.685 11.2739 8.81111 10.985L9.67778 10.1256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.606ee8c2e73dd1356b96924540aa743d.svg";
export { ForwardRef as ReactComponent };